import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../elements/logo/Logo';
import footer from '../../data/footer/footer.json';
import ScrollTop from './ScrollTop';

const footerDescription = footer[0];
const footerLinks = footer[1];
const footerLinksTwo = footer[2];
const footerSubscribe = footer[3];
const footerRefers = footerLinks.quicklink;
const footerRefersTwo = footerLinksTwo.quicklink;

const Footer = () => {
    return (
        <>
            <footer className="footer rn-footer footer-style-default">
                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            {/*Description */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <div className="newsletter-form ">
                                        <div className="logo">
                                            <Logo
                                                image={`${process.env.PUBLIC_URL}/images/logo/IEEE-Logo-Darkmode.svg`}
                                                image2={`${process.env.PUBLIC_URL}/images/logo/IEEE-Logo.svg`}
                                            />
                                        </div>
                                        <div className="bording"></div>
                                        <div className="logo logoStyling">
                                            <Logo
                                                image={`${process.env.PUBLIC_URL}/images/logo/logo-modern-light-red.svg`}
                                                image2={`${process.env.PUBLIC_URL}/images/logo/logo-modern.svg`}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="inner text-left">
                                    <div className="rn-footer-widget">
                                        <div>
                                            <h3 className="text-big">
                                                {footerDescription.title}
                                                <br></br>
                                                {footerDescription.title2}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*End Description */}
                            {/*Committee Description*/}
                            <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <h4 className="title">
                                        {footerLinks.title}
                                    </h4>
                                    <div className="inner">
                                        <ul className="footer-link link-hover">
                                            {footerRefers.map(
                                                (refes, index) => (
                                                    <li key={index}>
                                                        <Link
                                                            target="_blank"
                                                            to={`${refes.url}`}
                                                        >
                                                            {refes.text}
                                                        </Link>
                                                    </li>
                                                )
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/*End Committee Description*/}
                            {/*Start second commitee Description*/}
                            <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <div className="widget-menu-top">
                                        <h4 className="title">
                                            {footerLinksTwo.title}
                                        </h4>
                                        <div className="inner">
                                            <ul className="footer-link link-hover">
                                                {footerRefersTwo.map(
                                                    (data, index) => (
                                                        <li key={index}>
                                                            <Link
                                                                target="_blank"
                                                                to={`${data.url}`}
                                                            >
                                                                {data.text}
                                                            </Link>
                                                        </li>
                                                    )
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*Ending Second committee Description*/}
                            {/*Start Subscribe*/}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <h4 className="title">
                                        {footerSubscribe.title}
                                    </h4>
                                    <div className="inner">
                                        <h6 className="subtitle">
                                            {footerSubscribe.subtitle}
                                        </h6>
                                        <form
                                            className="newsletter-form"
                                            action="#"
                                        >
                                            <div className="form-group">
                                                <input
                                                    type="email"
                                                    placeholder="Enter Your Email Here"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <button
                                                    className="btn-default"
                                                    type="submit"
                                                >
                                                    Subscribe
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            {/*End Subscribe*/}
                        </div>
                    </div>
                </div>
            </footer>
            <ScrollTop />
        </>
    );
};
export default Footer;
